import { render, staticRenderFns } from "./SearchBarHeader.vue?vue&type=template&id=9be650d0&scoped=true"
import script from "./SearchBarHeader.vue?vue&type=script&lang=js"
export * from "./SearchBarHeader.vue?vue&type=script&lang=js"
import style0 from "./SearchBarHeader.vue?vue&type=style&index=0&id=9be650d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be650d0",
  null
  
)

export default component.exports